import QCheckboxButton from '../checkbox/src/checkbox-button.vue';


export default QCheckboxButton;
